import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import r from "react";
import e from "prop-types";
import t from "./ViewportManager.js";
var p = "767px",
  o = "991px",
  s = "1024px";
var i = {
    maxMobile: e.string,
    maxMobileLarge: e.string,
    maxTablet: e.string,
    maxTabletLarge: e.string,
    minDesktop: e.string
  },
  a = {
    maxMobile: "479px",
    maxMobileLarge: p,
    maxTablet: o,
    maxTabletLarge: "1023px",
    minDesktop: s
  };
var n = /*#__PURE__*/function (_r$Component) {
  _inherits(n, _r$Component);
  function n(r) {
    var _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, r)), t.register(_this.props);
    return _this;
  }
  _createClass(n, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      t.unregister(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? this.props.children : null;
    }
  }]);
  return n;
}(r.Component);
n.defaultProps = a, n.propTypes = i;
export { n as default };